define [], () ->
  console.log "routes execd alt2"
  name: 'alt2'
  public: true
  template: require('./home_alt2.jade')
  controller: require('./signup/signup.coffee')
  url: '^/alt2'



// WEBPACK FOOTER //
// ./components/home/routes_alt.coffee